const footer = document.querySelector('.footer');
const body = document.querySelector('body');



if (footer) {
  const linkCol = document.querySelectorAll('.footer .col .col-wrap ul > li');
  var scrolltopbtns = document.querySelectorAll('footer .up');


  if (linkCol.length > 0) {
    linkCol.forEach(element => {
      const link = element.querySelector('a');
      if (link) {
        try {
          const subLink = link.getAttribute('href');
          if (subLink) {
            const url = new URL(subLink);
            if (url.hostname != window.location.hostname) {

              element.querySelector('a').classList.add('externalLink');
            }
          }
        } catch (error) {
          element.querySelector('a').classList.remove('externalLink');
        }
      }
    });
  }

  document.addEventListener('scroll', function () {
    scrolltopbtns.forEach(button => {
      button.style.display = window.scrollY > 500 ? 'flex' : 'none';
    });
  });

  scrolltopbtns.forEach(button => {
    button.addEventListener('click', () => {
      const isSafari = body.classList.contains('safari');
      if (isSafari) {
        smoothScrollTo(0);
        // console.log('Scroll to top: Safari');
      } else {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
        // console.log('Scroll to top: Chrome/Other');
      }
    });
  });

  // Smooth scrolling fallback for Safari
  function smoothScrollTo(targetY) {
    const startY = window.scrollY || window.pageYOffset
    const distance = targetY - startY;
    const duration = 500; // ms
    const startTime = performance.now();

    function step(currentTime) {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1); // Clamp between 0 and 1
      const easeOutQuad = progress * (2 - progress); // Smooth easing
      window.scrollTo(0, startY + distance * easeOutQuad);

      if (progress < 1) {
        requestAnimationFrame(step);
      }
    }

    requestAnimationFrame(step);
  }

}
